import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Actions } from '@/features/workflows/lib/consts'
import type { IClient, IClientFetch } from '../models/client-schema'

interface ClientState {
  action: Actions[]
  setAction: (action: Actions[]) => void
  client: Partial<IClient>
  setClient: (client: Partial<IClient>) => void
  // Vacío hasta que se carga un cliente (los consumidores ya chequean con
  // isEmpty/optional chaining).
  clientOriginal: Partial<IClientFetch>
  setClientOriginal: (client: IClientFetch) => void
  clearData: () => void
  isHistory: boolean
  setIsHistory: (isHistory: boolean) => void
}

export const generateIdempotencyKey = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`
}

export const useClientStore = create<ClientState>()(
  persist(
    (set) => ({
      action: [],
      setAction: (data) => {
        set(() => ({ action: [...data] }))
      },
      isHistory: false,
      setIsHistory: (data) => {
        set(() => ({ isHistory: data }))
      },
      client: {},
      setClient: (data) => {
        set(() => ({ client: { ...data } }))
      },
      clientOriginal: {},
      setClientOriginal: (client) => {
        set(() => ({ clientOriginal: { ...client } }))
      },
      clearData: () => {
        set(() => ({ client: {} }))
        set(() => ({ clientOriginal: {} }))
        set(() => ({ action: [] }))
        set(() => ({ isHistory: false }))
      }
    }),
    {
      name: 'client-store'
    }
  )
)
